import { Link } from "react-router-dom";
import { articleCategories, articles } from "../../data/articles";
import Placeholder from "../../components/images/placeholder.png";
import { FadeIn, FadeInStagger } from "../utils/FadeIn";
import { usePublicWebPosts } from "../../hooks/usePublicWebPosts";
import { documentExcerpt, postPath } from "../../data/cmsPublic";

function fallbackCards() {
  return articles.slice(0, 3).map((article) => ({
    title: article.title,
    description: article.description || article.content,
    href: article.href || "/innlegg",
    imageSrc: article.imageSrc,
    author: article.author?.name || "Airon AS",
    category: articleCategories[(article.category || 1) - 1]?.title || "Artikkel",
  }));
}

export default function ArticlesSection() {
  const { items, loading, fromApi } = usePublicWebPosts();
  const live = items.slice(0, 3).map((post) => ({
    title: post.title,
    description: documentExcerpt(post, "Les mer hos Airon."),
    href: post.path || postPath(post),
    imageSrc: post.featured_image_url,
    author: post.author_name || "Airon AS",
    category: (post.tags && post.tags[0]) || "Innlegg",
  }));
  const shown = !loading && fromApi && live.length > 0 ? live : fallbackCards();

  return (
    <section className="sec" id="hjelp" style={{ background: "var(--bg-2)" }}>
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-tag">04 / Hjelp &amp; artikler</div>
          <h2>
            Lær mer om <em>ditt inneklima.</em>
          </h2>
          <Link
            to="/innlegg"
            className="sec-tag"
            style={{
              color: "var(--airon-3)",
              textDecoration: "none",
              fontFamily: "var(--mono)",
            }}
          >
            Alle innlegg →
          </Link>
        </div>

        <FadeInStagger>
          <div
            className="projects-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 20,
            }}
          >
            {shown.map((article) => (
              <FadeIn key={article.title}>
                <article
                  className="project"
                  style={{
                    background: "#fff",
                    border: "1px solid var(--line)",
                    borderRadius: 20,
                    padding: 18,
                    display: "flex",
                    flexDirection: "column",
                    gap: 14,
                    transition:
                      "transform 0.2s, box-shadow 0.2s, border-color 0.2s",
                  }}
                >
                  <div
                    className="thumb"
                    style={{
                      position: "relative",
                      width: "100%",
                      aspectRatio: "16 / 10",
                      borderRadius: 14,
                      overflow: "hidden",
                      background: "var(--bg-2)",
                    }}
                  >
                    <img
                      src={article.imageSrc || Placeholder}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                    <span
                      className="tag"
                      style={{
                        position: "absolute",
                        top: 12,
                        left: 12,
                        background: "rgba(255,255,255,0.92)",
                        color: "var(--ink-2)",
                        border: "1px solid var(--line)",
                        borderRadius: 999,
                        padding: "4px 10px",
                        fontSize: 10,
                        fontFamily: "var(--mono)",
                        letterSpacing: "0.06em",
                        textTransform: "uppercase",
                      }}
                    >
                      {article.category}
                    </span>
                  </div>
                  <h3
                    style={{
                      fontFamily: "var(--display)",
                      fontSize: 20,
                      lineHeight: 1.25,
                      color: "var(--ink)",
                      margin: 0,
                      fontWeight: 500,
                    }}
                  >
                    <Link to={article.href} style={{ color: "inherit" }}>
                      {article.title}
                    </Link>
                  </h3>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 14,
                      lineHeight: 1.55,
                      color: "var(--ink-2)",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {article.description}
                  </p>
                  <div
                    style={{
                      marginTop: "auto",
                      paddingTop: 12,
                      borderTop: "1px solid var(--line)",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontFamily: "var(--mono)",
                      fontSize: 11,
                      color: "var(--muted)",
                      textTransform: "uppercase",
                      letterSpacing: "0.06em",
                    }}
                  >
                    <span>{article.author}</span>
                    <Link to={article.href} style={{ color: "var(--airon-3)" }}>
                      Les mer →
                    </Link>
                  </div>
                </article>
              </FadeIn>
            ))}
          </div>
        </FadeInStagger>
      </div>
    </section>
  );
}
